import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)
// state
const state = {
    count: 1,
    token:"",
    lngLat:"",
    title:null
}
// getters
const getters = {
    count: state => state.count,
    count: state => state.token,
    title: state => state.title

}
//mutations
const mutations = {
    increment: state => state.count++,
    decrement: state => state.count--,
    setToken:(state,payload) => {
        state.token=payload;
    },
    setLngLat:(state,payload) => {
        state.lngLat=payload;
    },
    setTitle:(state,title) => {
        state.title=title;
    },
}
//actions
const actions = {
    increment: ({ commit }) => commit('increment'),
    decrement: ({ commit }) => commit('decrement')
}
export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
})



